import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SupplierNavbar from "./SuppplierNavbar";
import SupplierSidebar from "./SupplierSidebar";
import "./Supplier.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Axios from "../../../axios/axios";

function SupplierDashboard() {
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [counts, setCounts] = useState({
    requested: 0,
    approved: 0,
    delivered: 0,
    monthlyRevenue: 0,
    pendingPaymentsCount: 0,
    pendingPaymentsTotal: 0
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (window.innerWidth < 768) setSidebarOpen(false);
  }, [location]);

  useEffect(() => {
    fetchSupplierData();
  }, []);

  const fetchSupplierData = async () => {
    try {
      const storedSupplier = sessionStorage.getItem("supplierInfo");
      if (!storedSupplier) return;
      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);

      const config = { headers: { "x-supplier-id": supplierInfo.supplierId } };

      const [
        supplierRes,
        requestedRes,
        pendingRes,
        deliveredRes,
        deliveredStatusRes,
        pendingPaymentRes
      ] = await Promise.all([
        Axios.get(`/supplier/get/${supplierInfo.supplierId}`),
        Axios.get("/supplier/orders/requested", config),
        Axios.get("/supplier/orders/pending", config),
        Axios.get("/supplier/orders/delivered", config),
        Axios.get(`/supplier/${supplierInfo.supplierId}?status=delivered`),
        Axios.get(`/supplier/pending-payments/${supplierInfo.supplierId}`)
      ]);

      const supplierData = supplierRes.data.data || {};

      const deliveredOrders = deliveredStatusRes.data.orders || [];
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();

      const currentMonthRevenue = deliveredOrders
        .filter(order => {
          const orderDate = new Date(order.orderDate);
          return (
            orderDate.getMonth() === currentMonth &&
            orderDate.getFullYear() === currentYear
          );
        })
        .reduce((sum, order) => sum + (order.total || 0), 0);

      const pendingPayments = pendingPaymentRes.data?.payments || [];
      const totalPendingAmount = pendingPayments.reduce((sum, item) => sum + (item.amount || 0), 0);

      setCounts({
        requested: requestedRes.data.length || 0,
        approved: pendingRes.data.length || 0,
        delivered: deliveredRes.data.length || 0,
        monthlyRevenue: currentMonthRevenue || 0,
        pendingPaymentsCount: pendingPayments.length || 0,
        pendingPaymentsTotal: totalPendingAmount
      });
    } catch (error) {
      console.error("Error fetching supplier dashboard data:", error);
    }
  };

  const cards = [
    {
      title: "Total Orders Requested",
      value: counts.requested,
      icon: "bi-clipboard-data",
      bg: "card-icon-secondary",
      type: "requested"
    },
    {
      title: "Approved Orders",
      value: counts.approved,
      icon: "bi-hourglass-split",
      bg: "card-icon-warning",
      type: "pending"
    },
    {
      title: "Delivered Orders",
      value: counts.delivered,
      icon: "bi-truck",
      bg: "card-icon-success",
      type: "delivered"
    },
    {
      title: "This Month Revenue",
      value: counts.monthlyRevenue,
      icon: "bi-currency-rupee",
      bg: "card-icon-info"
    },
    {
      title: "Pending Payments",
      value: counts.pendingPaymentsCount,
      icon: "bi-cash-stack",
      bg: "card-icon-danger",
      type: "pendingPayments"
    }
  ];

  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />
      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar closeSidebar={() => {
                if (window.innerWidth < 768) setSidebarOpen(false);
              }} />
            </div>
          )}
          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="dashboard-main">
              <h2 className="dashboard-title mb-4">Supplier Dashboard</h2>
              <div className="row g-4">
                {cards.map((card, i) => (
                  <div className="col-md-4 col-lg-3" key={i}>
                    <div
                      className="enhanced-card p-4 text-center"
                      onClick={() => {
                        if (card.type === "pendingPayments") {
                          navigate("/supplier/payments-list?status=Pending");
                        } else if (card.type) {
                          navigate(`/supplier/orders/${card.type}`);
                        }
                      }}
                      style={{ cursor: card.type ? "pointer" : "default" }}
                    >
                      <div className={`card-icon-wrapper ${card.bg}`}>
                        <i className={`bi ${card.icon} fs-2`}></i>
                      </div>
                      <h6 className="text-muted">{card.title}</h6>
                      <div className="card-value">{card.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierDashboard;
